<template>
  <div class="edit-charge" :class="[type + '-charge']">
    <div class="per-run-item posterStyle">
      <div class="per-run-item-title personal-vip-title">
        <span>{{ title }}</span>
        <i class="vip">VIP</i>
      </div>
      <div class="right">
        <el-select class="per-run-item-select" v-model="charge" size="mini" @change="changeBuyLink(charge, 'charge')">
          <el-option :key="'charge' + 0" label="公开免费" :value="0"></el-option>
          <el-option :key="'charge' + 1" label="付费阅读" :value="1"></el-option>
          <el-option v-if="type === 'book'" :key="'charge' + 2" label="内部阅读" :value="2"></el-option>
        </el-select>
      </div>
    </div>
    <div class="per-run-item posterStyle" v-if="charge == 1 && type === 'book'">
      <div class="per-run-item-title">
        <span class="title">付费图标</span>
      </div>
      <div class="right">
        <el-select class="per-run-item-select" v-model="chargeIconType" size="mini" @change="chargeIconSelectChange">
          <el-option v-for="item in chargeIconOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <div class="uploadlogo" v-show="chargeIconType === -1">
          <div class="upload">
            <el-select class="per-run-item-select pic-list" size="mini" v-model="chargeIcon">
              <el-option class="pic-list-item question-icon" v-for="(item, index) in uploadChargeIconList" :key="'chargePic' + index" :label="item.name" :value="item.path">
                {{ item.name }}
                <img class="select-del" src="@imgs/delete-gray.png" @click="delIcon(item, $event)" />
              </el-option>
            </el-select>
            <label class="uploadlogoButton" for="chargePicButton">上传</label>
            <input
              type="file"
              id="chargePicButton"
              ref="chargePic"
              value="imgFile"
              accept="image/png, image/jpg, image/jpeg, image/gif"
              @change="uploadShopImg($event, 'chargeIcon')"
              style="display: none"
            />
          </div>
          <div v-if="chargeIcon && chargeIcon.length > 2" class="thumbnail"><img :src="chargeIcon" alt="" /></div>
          <div class="thumbnail upload-tip" v-else>
            <p>建议尺寸80*80</p>
            <p>显示效果最佳</p>
          </div>
        </div>
      </div>
    </div>
    <div class="per-run-item posterStyle" v-if="charge == 1 && type === 'book' && chargeIconType >= 20">
      <div class="per-run-item-title">
        <span class="title">文字内容</span>
      </div>
      <div class="right">
        <el-input style="width: 135px" v-model="chargeIcon" placeholder="请输入" @change="checkWord" maxlength="12" size="mini"></el-input>
        <div class="warning-text" v-if="showWarning">请输入1-6个汉字</div>
      </div>
    </div>
    <div class="per-run-item posterStyle" v-if="charge == 1 && type === 'book' && chargeIconType >= 20">
      <div class="per-run-item-title">
        <span class="title">文字样式</span>
      </div>
      <div class="right">
        <el-select class="personal-item-select pic-list" size="mini" v-model="textIconStyle">
          <el-option class="pic-list-item question-icon" v-for="(item, index) in textIconStyleOptions" :key="'shopText' + index" :label="item.label" :value="item.value">
            {{ item.label }}
          </el-option>
        </el-select>
      </div>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickCancel="deleteCancel" @clickConfirm="deleteConfirm" :appendToBody="true"></TipDialog>
  </div>
</template>

<script>
import { getStrByteCount, uploadIconPic } from '@/utils'
import compareVipRight from '@components/common/compareVipRight.js'
import TipDialog from '@components/common/TipDialog.vue'
import setBook from '@api/setBook'
import vips from '@api/vip'
export default {
  name: 'EditCharge',
  data() {
    return {
      chargeIconOptions: [
        {
          value: 0,
          label: '购买电子书'
        },
        {
          value: 1,
          label: '购买电子刊'
        },
        {
          value: 2,
          label: '购买数字报'
        },
        {
          value: 6,
          label: '订阅数字内容'
        },
        {
          value: -1,
          label: '自定义图片图标'
        },
        {
          value: 20,
          label: '自定义文字图标'
        }
      ],
      textIconStyleOptions: [
        {
          value: 20,
          label: '样式一'
        },
        {
          value: 21,
          label: '样式二'
        }
      ],
      showWarning: false,
      uploadChargeIconList: [],
      deletePic: null,
      isAuthorized: false,
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '是否确认删除？'
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  watch: {
    charge(val) {
      if (val === 1 && !this.compare({ type: 'boole', key: 'charge' })) {
        this.charge = 0
      }
    }
  },
  mixins: [compareVipRight],
  components: {
    TipDialog
  },
  computed: {
    title() {
      return '阅读条件'
    },
    chargeIconType: {
      get: function() {
        return this.$store.state.config.bookObj.chargeIconType > 20 ? 20 : this.$store.state.config.bookObj.chargeIconType
      },
      set: function(value) {
        this.$store.commit('config/CHARGE_ICON_TYPE', value)
      }
    },
    textIconStyle: {
      get: function() {
        return this.$store.state.config.bookObj.chargeIconType
      },
      set: function(value) {
        this.$store.commit('config/CHARGE_ICON_TYPE', value)
      }
    },
    charge: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].charge
      },
      set: function(value) {
        this.$store.commit('config/CHARGE', { type: this.type + 'Obj', value: value })
      }
    },
    chargeIcon: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].chargeIcon
      },
      set: function(value) {
        this.$store.commit('config/CHARGE_ICON', { type: this.type + 'Obj', value: value })
      }
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  methods: {
    async changeBuyLink(value, type) {
      if (value === 1) {
        if (!this.isAuthorized) {
          this.memberDialogOptions.type = 'info'
          this.memberDialogOptions.tip = '您的账号还未进行认证，请与工作人员联系完成验证。<br />4007-789-600<br />010-82531751'
          this.$refs.memberDialog.visible = true
          this.$nextTick(() => {
            this.charge = 0
          })
          return
        }
        if (!(await this.compare({ type: 'boole', key: type }))) {
          this.memberDialogOptions.type = 'member'
          this.memberDialogOptions.tip = `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
          this.$refs.memberDialog.visible = true
          this.$nextTick(() => {
            this.charge = 0
          })
          return
        }
      }
    },
    chargeIconSelectChange(value) {
      if (value === -1) {
        this.isUpload = true
        this.chargeIcon = ''
      } else {
        this.isUpload = false
        if (value < 20) {
          this.chargeIcon = value
        } else {
          this.chargeIcon = ''
        }
      }
    },
    checkWord(value) {
      let strByteCount = getStrByteCount(value)
      this.showWarning = strByteCount > 12 || strByteCount < 1
    },
    delIcon(item, e) {
      this.deletePic = item
      this.$refs.deleteDialog.visible = true
    },
    async uploadShopImg(e, type) {
      const result = await uploadIconPic(e, type, 1, this)
      if (result && result.length > 0) {
        this.uploadChargeIconList = result
        this.chargeIcon = this.uploadChargeIconList[0].path
      }
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
      this.deletePic = null
    },
    async getImage(module) {
      await setBook.getImageList({ module: module }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          if (module === 'chargeIcon') {
            this.uploadChargeIconList = res.data.data
          }
        } else {
          console.log('获取图片列表失败')
        }
      })
    },
    deleteConfirm() {
      let module = this.deletePic.module
      setBook.delImage({ ids: this.deletePic.id }).then((res) => {
        if (res.status === 200 && res.data.code === 0) {
          this.getImage(module)
          this.chargeIcon = ''
        } else {
          console.log('删除列表失败')
        }
      })
      this.deletePic = null
      this.$refs.deleteDialog.visible = false
    }
  },
  mounted() {
    this.getImage('chargeIcon')
    if (!this.compare({ type: 'boole', key: 'charge' })) {
      this.$nextTick(() => {
        this.charge = 0
      })
    }
  },
  created() {
    vips.getAuthenUserByLoginName().then((res) => {
      this.isAuthorized = res.data && res.data.status === 0
    })
  }
}
</script>

<style lang="scss" scoped>
.edit-charge {
  .per-run-item {
    display: flex;
    align-items: center;
    margin-top: 18px;
    &.flex-start {
      align-items: flex-start;
    }
    .warning-text {
      color: #d33636;
    }
    .per-run-item-title {
      display: inline-block;
      margin-right: 10px;
      font-size: 13px;
      width: 115px;
      text-align: right;
      white-space: nowrap;
      line-height: 24px;
      span {
        height: 100%;
        line-height: 24px;
      }
      i {
        width: 30px;
        line-height: 20px;
        background: #df5813;
        text-align: center;
        color: #fff;
        font-size: 10px;
        margin-left: 5px;
        border-radius: 2px;
        font-style: normal;
        font-weight: bold;
      }
    }
    .right {
      .uploadlogoButton {
        width: 55px;
        height: 24px;
        background: #df5813;
        color: #fff;
        border-radius: 15px;
        font-size: 14px;
        display: inline-flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin: 10px 0 0 8px;
        cursor: pointer;
      }
    }
    .per-run-item-select {
      &.el-select {
        width: 90px;
        .el-input {
          .el-input__inner {
            border-color: #cecece;
            height: 24px;
            font-size: 13px;
            padding: 0 5px;
            line-height: 24px;
          }
        }
      }
      .el-icon-arrow-up::before {
        color: #515151;
      }
    }
  }
  .poster {
    .right {
      .el-select {
        width: 136px !important;
      }
    }
  }
  .posterStyle {
    align-items: flex-start;
  }
  .thumbnail {
    width: 120px;
    height: 35px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    p {
      width: 100%;
      text-align: center;
      font-size: 14px;
      margin: 0;
      line-height: 17px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  &.bookShelf-charge {
    .per-run-item {
      &:first-child {
        flex-direction: column;
        .per-run-item-title {
          font-size: 16px;
          margin-bottom: 5px;
          text-align: left;
        }
        .right {
          .per-run-item-select {
            width: 200px;
            height: 28px;
            margin-bottom: 10px;
          }
        }
      }
      &:nth-child(2) {
        .per-run-item-title {
          width: 55px;
        }
        .right {
          .per-run-item-select {
            width: 150px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
